import { Container, Divider } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { Box, Grid, Typography } from "@mui/material";
import axios from "axios";
import {
  AutoCompleteComponent,
  AutoCompleteWithSearch,
  CheckboxInput,
  CurrencyDisplay,
  CurrencyNumberInput,
  CustomTable,
  DatePicker,
  DateRangePicker,
  FormLabel,
  ModalError,
  MonthYearRangePicker,
  Page,
  PrimaryButton,
  SearchTextInput,
  SectionLabel,
  SelectInput,
  SkeletonComponent,
  SwitchInput,
  TableAction,
  TableCellMultipleRow,
  TextInput,
} from "components";
import { HeaderTitle } from "layouts";
import {
  calculateSingleTax,
  calculateTotalClaimsBaseRevenue,
  calculateTotalClaimsRevenue,
  calculateTotalRevenue,
  calculateTotalTaxClaim,
  getTotalPage,
} from "lib";
import { debounce } from "lodash";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import {
  formatPayloadDate,
  formatPeriodMonthYearFromString,
  getErrors,
  getNestedValue,
  textCapitalization,
} from "utils";
import {
  ModalAddSong,
  ModalBulkAdd,
  ModalSongResults,
  ModalUploadResults,
} from "./ModalInvoice";

function FormInvoice({
  pageTitle,
  pageSubTitle,
  loadingPage,
  onSubmitPayload,
  setLoadingPage,
}) {
  const params = useParams();
  const classes = globalStyles();
  const history = useHistory();
  const isFirstLoad = useRef(true);
  const isSubmittingRef = useRef(false);
  const isInitExchangeRate = useRef(true);
  const token = localStorage.getItem("token");
  const isEditing = params?.id;
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingButton, setLoadingButton] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [dataTableTaxes, setDataTableTaxes] = useState([]);
  const [payload, setPayload] = useState({
    transaction_name: "claim",
    type: "usage",
    invoice_number: "",
    transaction_number: "",
    po_number: "",
    invoice_date: moment(),
    dsp_id: 0,
    end_date: moment(),
    start_date: moment(),
    exchange_rate: 0,
    job_number: "",
    account_number: "",
    is_all_song: false,
    songs: [],
    header_ids: [],
    is_draft: false,
    tax_ids: [],
    rounding: false,
  });
  const [submiting, setSubmitting] = useState(false);

  const [optionClient, setOptionClient] = useState([]);
  const [optionBankAccount, setOptionBankAccount] = useState([]);
  const [showTaxes, setShowTaxes] = useState(false);
  const [showModalBulkAdd, setShowModalBulkAdd] = useState(false);
  const [showModalAddSong, setShowModalAddSong] = useState(false);
  const [showModalSongResults, setShowModalSongResult] = useState(false);
  const [showModalUploadResults, setShowModalUploadResults] = useState(false);
  const [uploadedSong, setUploadedSong] = useState({});
  const [tableParams, setTableParams] = useState({
    page: 1,
    size: 10,
    dsp_id: "",
    search: "",
    start_date: null,
    end_date: null,
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [optionListRightTypes, setOptionListRightTypes] = useState([
    { key: 0, value: "none" },
  ]);
  const [searchDsp, setSearchDsp] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const isUsageInvoice = payload?.type === "usage";
  const payloadDspId = payload?.dsp_id;
  const selectedDSP = optionClient?.find(dsp =>
    isUsageInvoice
      ? dsp.dsp_id === payloadDspId || dsp?.master_client_id === payloadDspId
      : dsp.id === tableParams?.dsp_id
  );
  const selectedTaxes = payload?.tax_ids;
  const selectedClaims = payload?.header_ids;
  const checkSelectedTaxes = selectedTaxes?.length > 0;
  const isOverseas = selectedDSP && selectedDSP?.domicile === "overseas";
  const isLocalCurrency = selectedDSP?.currency_symbol
    ? selectedDSP?.currency_symbol === "Rp"
    : isUsageInvoice
    ? selectedDSP?.fee_currency?.currency_symbol_code === "Rp" ||
      selectedDSP?.fee_currency === null
    : selectedDSP?.dsp_currency?.currency_symbol_code === "Rp" ||
      selectedDSP?.dsp_currency === null;
  const isForeignCurrency =
    selectedDSP &&
    selectedDSP?.currency_symbol !== null &&
    selectedDSP?.currency_symbol !== "Rp";
  const showExchangeRate =
    selectedDSP &&
    !isLocalCurrency &&
    (isUsageInvoice
      ? selectedDSP?.fee_currency?.currency_symbol !== null
      : selectedDSP?.dsp_currency?.currency_symbol !== null);
  const selectedCurrencyCode =
    selectedDSP?.fee_currency?.currency_symbol_code ||
    selectedDSP?.dsp_currency?.currency_symbol_code ||
    selectedDSP?.currency_symbol ||
    selectedClaims?.[0]?.dsp_currency_symbol ||
    "Rp ";

  const songsWithQty = payload?.songs?.map(item => ({
    ...item,
    qty: item?.qty || 1,
  }));
  const isRounded = payload?.rounding;
  const totalFee = isUsageInvoice
    ? calculateTotalRevenue(songsWithQty || []) * (payload?.exchange_rate || 1)
    : payload?.exchange_rate
    ? calculateTotalClaimsRevenue(
        payload?.header_ids || [],
        payload?.exchange_rate || 1
      )
    : calculateTotalClaimsBaseRevenue(payload?.header_ids, 1);
  const dspCurrencyId =
    selectedDSP?.currency_id || selectedDSP?.dsp_currency?.id;
  const totalTax = calculateTotalTaxClaim(selectedTaxes, totalFee);
  const totalRevenueAfterTax = totalFee + (showTaxes && totalTax);
  const initialPayload = useRef(payload);
  const hasPayloadChanges =
    JSON.stringify(initialPayload?.current) !== JSON.stringify(payload);
  const hasChanges = isEditing ? false : hasPayloadChanges;
  const songDetailButtonAction = buttonAddList({
    uploadedSong,
    setShowModalSongResult,
    showModalSongResults,
    setShowModalBulkAdd,
    showModalBulkAdd,
    setShowModalAddSong,
    showModalAddSong,
  });
  const disabledCheckbox = item => {
    const preloadedDsp = item?.dsp_id !== payload?.dsp_id;
    const isSameDsp = selectedClaims.some(
      selected => selected.dsp_id === item.dsp_id
    );
    const isSamePeriod = selectedClaims.some(
      selected => selected.period === item.period
    );
    const hasSelection = selectedClaims.length > 0;

    const isDisabled = isEditing
      ? hasSelection
        ? !(isSameDsp && isSamePeriod)
        : preloadedDsp
      : hasSelection && !(isSameDsp && isSamePeriod);
    return isDisabled;
  };

  const handleChangeTableParams = (value, key) => {
    setTableParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleCloseModalBulkAdd = (_, reason) => {
    if (reason && (reason === "backdropClick" || reason === "escapeKeyDown")) {
      return;
    }
    setShowModalBulkAdd(false);
  };
  const handleCloseModalAddSong = () => setShowModalAddSong(false);
  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleAddSong = item => {
    const modifiedTable = item?.map(item => {
      const revenueValue = Number(item?.revenue_number || item?.revenue);
      return {
        ...item,
        revenue: revenueValue || 0,
        right_type_id: item?.type || item?.right_type_id,
        type: item?.type || item?.right_type_id,
        qty: 1,
      };
    });
    const combinedSong = [...modifiedTable, ...payload?.songs];
    const removeDuplicated = combinedSong.filter(
      (item, index, self) =>
        index === self.findIndex(t => t.song_id === item.song_id)
    );
    handleChangePayload(removeDuplicated, "songs");
    handleCloseModalAddSong();
  };
  const handleChangeCheckboxClaim = item => {
    const newSelectedClaims = [...selectedClaims];
    const isAlreadySelected = newSelectedClaims?.some(claim =>
      claim?.header_id
        ? claim?.header_id === item?.header_id
        : claim === item?.header_id
    );
    if (isAlreadySelected) {
      const result = newSelectedClaims?.filter(claim =>
        claim?.header_id
          ? claim?.header_id !== item?.header_id
          : claim !== item?.header_id
      );
      handleChangePayload(result, "header_ids");
    } else {
      const result = [...newSelectedClaims, item];
      handleChangePayload(result, "header_ids");
    }
  };
  const handleChangeCheckboxTaxes = (_, item) => {
    const newSelectedTaxes = [...selectedTaxes];
    const isAlreadySelected = newSelectedTaxes.some(
      taxes => taxes?.id === item?.id
    );
    if (isAlreadySelected) {
      const result = newSelectedTaxes?.filter(taxes => taxes?.id !== item?.id);
      handleChangePayload(result, "tax_ids");
    } else {
      const result = [...newSelectedTaxes, item];
      handleChangePayload(result, "tax_ids");
    }
  };
  const handleChangeStartDate = date => {
    handleChangeTableParams(date, "start_date");
  };
  const handleChangeEndDate = date => {
    handleChangeTableParams(date, "end_date");
  };
  const handleChangeType = event => {
    setPayload(currentState => ({
      ...currentState,
      ...(isUsageInvoice ? { header_ids: [] } : { songs: [] }),
      dsp_id: 0,
      type: event?.target?.value,
      exchange_rate: 0,
      account_number: "",
      job_number: "",
      rounding: false,
      tax_ids: [],
    }));
    setShowTaxes(false);
  };

  const getTaxesList = async () => {
    let url = `${hardBaseUrl}/transaction/v2/tax/sales`;
    if (selectedDSP) {
      if (payload?.type === "usage") {
        url = `${hardBaseUrl}/transaction/v2/tax/sales?master_client_id=${selectedDSP?.master_client_id}`;
      } else {
        url = `${hardBaseUrl}/transaction/v2/tax/sales?dsp_id=${selectedDSP?.dsp_id}`;
      }
    }
    try {
      const res = await axios.get(url, { headers });
      const { data } = res?.data;
      setDataTableTaxes(data);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getClaimList = async () => {
    const { start_date, end_date, ...restParams } = tableParams;
    try {
      const res = await axios.get(
        `${hardBaseUrl}/publisher/transaction/v2/sales-invoice/list-claim${
          isEditing ? `/${params?.id}` : ""
        }`,
        {
          headers,
          params: {
            ...restParams,
            start_date: formatPayloadDate(start_date),
            end_date: formatPayloadDate(end_date),
          },
        }
      );
      const { meta, data } = res?.data;
      const result = data?.sort((a, b) => a?.header_id - b?.header_id);
      setDataTable(result);
      const pageCount = getTotalPage(meta?.total, tableParams?.size || 1);
      setTableTotalPage(pageCount);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getClientList = async () => {
    const url = isUsageInvoice
      ? `${hardBaseUrl}/master/client`
      : `${hardBaseUrl}/publishers/list-dsp`;
    const params = {
      page: 1,
      size: 10,
      search: searchDsp || "",
    };
    try {
      setLoadingSearch(true);
      const res = await axios.get(url, { headers, params });
      const { data } = res?.data;
      const modifiedData = (data || [])?.map(item => ({
        ...item,
        id: item?.dsp_id || item?.master_client_id,
        label: item?.dsp_name || item?.name,
      }));
      setOptionClient(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingSearch(false);
    }
  };
  const debounceSearchDsp = useCallback(
    debounce(() => {
      getClientList();
    }, 500),
    [payload?.type, searchDsp]
  );
  const getDetailDSP = async dsp_id => {
    try {
      const res = await axios.get(`${hardBaseUrl}/dsp/${dsp_id}`, { headers });
      const { data } = res?.data;

      const modifiedData = {
        ...data,
        id: data?.dsp_id,
        label: data?.name,
      };
      setOptionClient([modifiedData]);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getRoyaltyType = async () => {
    const url = `${hardBaseUrl}/right_types`;
    try {
      const response = await axios.get(url, { headers });
      const modifiedData = (response?.data?.data || [])?.map(item => ({
        ...item,
        key: item?.id,
        value: item?.right_type_name,
      }));
      setOptionListRightTypes(modifiedData || []);
    } catch (error) {
      new Error(error);
    }
  };
  const getExchangeRate = async dspCurrencyId => {
    const currentDate = moment().format("DD MMM YYYY");

    const url = `${hardBaseUrl}/exchange-rate/code`;
    const params = {
      currency_id: dspCurrencyId,
      upload_date: currentDate,
    };
    if (dspCurrencyId !== 4) {
      try {
        const res = await axios.get(url, { headers, params });
        const resValue = res?.data?.data?.value;

        if (isForeignCurrency) {
          handleChangePayload(Number(resValue), "exchange_rate");
        } else {
          handleChangePayload(Number(1), "exchange_rate");
        }
      } catch (error) {
        ModalError(getErrors(error?.response));
        handleChangePayload(Number(1), "exchange_rate");
      }
    } else {
      handleChangePayload(Number(1), "exchange_rate");
    }
  };
  const getBaseCurrency = async () => {
    const { dsp_id, start_date, end_date } = payload;
    try {
      const res = await axios.get(
        `${hardBaseUrl}/publisher/transaction-claim/total-dsp-revenue`,
        {
          headers,
          params: {
            dsp_id,
            start_date: start_date.format("YYYY-MM"),
            end_date: end_date.format("YYYY-MM"),
          },
        }
      );
      const { data } = res?.data;
      handleChangePayload(Number(data?.original_currency_revenue), "revenue");
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDetailInvoice = async () => {
    try {
      const url = `${hardBaseUrl}/publisher/transaction/v2/sales-invoice/edit/${params?.id}`;
      const response = await axios.get(url, { headers });
      const result = response?.data?.data?.data || {};
      setPayload(payload => ({
        ...payload,
        ...result,
        dsp_id: result?.dsp_id,
        po_number: result?.po_number,
        invoice_date: moment(result?.invoice_date),
        exchange_rate: result?.exchange_rate,
        invoice_number: result?.invoice_number || "",
        start_date: moment(result?.start_date),
        end_date: moment(result?.end_date),
        header_ids: result?.selected_claims || [],
        type: result?.type || "",
        tax_ids: result?.selected_taxes || [],
      }));
      setShowTaxes(result?.tax_ids?.length > 0);
      getDetailDSP(result?.dsp_id);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getListBankAccount = async () => {
    const url = `${hardBaseUrl}/publisher/bank`;
    try {
      const res = await axios.get(url, { headers });
      const resData = res?.data?.data;
      if (res?.data?.meta?.http_status === 200) {
        setOptionBankAccount(resData);
      }
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const postUploadDocuments = async item => {
    const formData = new FormData();
    formData.append("file", item[0]);
    try {
      setLoadingButton(true);
      const res = await axios.post(
        `${hardBaseUrl}/publisher/transaction-song/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { data } = res?.data;
      const validSongs = data?.valid_songs;
      const processSongs = validSongs.map(item => {
        const uniqueComposers = [...new Set(item.composers)];
        return {
          ...item,
          composers: uniqueComposers,
          qty: 1,
        };
      });
      const mergeResult = [...payload?.songs, ...processSongs];
      const modifiedTable = Array.from(
        new Set(mergeResult.map(song => song?.song_id))
      ).map(song_id => mergeResult.find(song => song?.song_id === song_id));
      handleChangePayload(modifiedTable, "songs");
      setUploadedSong(data);
      handleCloseModalBulkAdd();
      setShowModalUploadResults(true);
    } catch (error) {
      ModalError(getErrors(error?.response));
      handleCloseModalBulkAdd();
    } finally {
      setLoadingButton(false);
    }
  };
  const handleSubmitPayload = (isDraft = false) => {
    setSubmitting(true);
    const {
      type,
      invoice_number,
      po_number,
      invoice_date,
      dsp_id,
      end_date,
      start_date,
      exchange_rate,
      job_number,
      account_number,
      songs,
      rounding,
    } = payload;
    const modifiedPayload = {
      exchange_rate,
      account_number,
      job_number,
      invoice_number,
      invoice_date: formatPayloadDate(invoice_date),
      po_number,
      dsp_id: isUsageInvoice ? dsp_id : selectedClaims?.[0]?.dsp_id || dsp_id,
      tax_ids: showTaxes ? selectedTaxes?.map(tax => tax?.id) : [],
      type,
      is_draft: isDraft,
      rounding,
      ...(isUsageInvoice
        ? {
            start_date: formatPayloadDate(start_date),
            end_date: formatPayloadDate(end_date),
            songs: songs?.map(song => ({
              song_id: song?.song_id,
              song_title: song?.song_title,
              right_type_id: song?.right_type_id || song?.type,
              revenue: song?.revenue,
              notes: song?.notes,
              composers: (song?.composers || [])?.map(
                ({ composer_id, ownership_percentage }) => ({
                  composer_id,
                  ownership_percentage,
                })
              ),
            })),
          }
        : {
            header_ids: selectedClaims?.map(val => val?.header_id || val),
          }),
    };
    onSubmitPayload(modifiedPayload);
    isSubmittingRef.current = true;
    setSubmitting(false);
  };
  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [];
    if (isEditing) {
      promises.push(getDetailInvoice());
    }
    if (!isEditing && isUsageInvoice) promises.push(getClientList());
    promises.push(getTaxesList());
    promises.push(getListBankAccount());
    promises.push(getRoyaltyType());

    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
      isFirstLoad.current = false;
    }
  };

  useEffect(() => {
    getTaxesList();
  }, [selectedDSP]);

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (!isFirstLoad.current) {
      setSearchDsp("");
    }
  }, [payload?.type]);
  useEffect(() => {
    if (!isFirstLoad.current) {
      const isSearching =
        Boolean(searchDsp) && searchDsp !== selectedDSP?.label;
      if (isSearching) {
        debounceSearchDsp();
        return () => {
          debounceSearchDsp.cancel();
        };
      } else if (!selectedDSP) {
        getClientList();
      }
    }
  }, [payload?.type, searchDsp, debounceSearchDsp]);
  useEffect(() => {
    if (!isUsageInvoice) {
      getClaimList();
    }
  }, [tableParams, payload?.type]);
  useEffect(() => {
    if (payloadDspId) {
      getBaseCurrency();
    }
  }, [payloadDspId, payload?.start_date, payload?.end_date]);
  useEffect(() => {
    if (dspCurrencyId && isForeignCurrency && !isInitExchangeRate.current) {
      getExchangeRate(dspCurrencyId);
    }
  }, [selectedDSP, isForeignCurrency]);
  useEffect(() => {
    const handleBeforeUnload = event => {
      if (hasChanges && !isSubmittingRef.current) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasChanges]);
  useEffect(() => {
    const unblock = history.block(() => {
      if (hasChanges && !isSubmittingRef.current) {
        return "You have unsaved changes. Are you sure you want to leave this page?";
      }
    });

    return () => {
      unblock();
    };
  }, [history, hasChanges]);
  useEffect(() => {
    if (!isUsageInvoice && payload?.header_ids?.length > 0) {
      handleChangeTableParams(payload?.header_ids?.[0]?.dsp_id, "dsp_id");
    }
  }, [payload?.header_ids]);

  return (
    <Page className={classes?.root} title={pageTitle}>
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={`${isEditing ? "Edit" : "Create"} Sales Invoice`}
            breadcrumbData={breadcrumbData(pageTitle)}
            backButton
          />
          <Divider className={classes?.divider} />
          <SectionLabel subTitle={pageSubTitle} />
          <Grid container my="16px">
            <Grid item xs={12} md={4}>
              <FormLabel label="Invoice Type" />
              <SelectInput
                value={payload?.type}
                onChange={handleChangeType}
                options={listInvoiceType}
                optionKey="key"
                optionLabel="name"
                disabled={isEditing}
                width={150}
              />
            </Grid>
          </Grid>
          <Box border="1px solid #ebebeb" borderRadius="6px" p="24px" mt="16px">
            <Grid container columnSpacing={2} rowSpacing={1} spacing={2}>
              <Grid item xs={12} md={6}>
                <FormLabel label="Invoice Number" required />
                <TextInput
                  disabled={isEditing}
                  placeholder="Invoice Number"
                  value={payload?.invoice_number}
                  onChange={event =>
                    handleChangePayload(event?.target?.value, "invoice_number")
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="PO Number" />
                <TextInput
                  placeholder="PO Number"
                  value={payload?.po_number}
                  onChange={event =>
                    handleChangePayload(event?.target?.value, "po_number")
                  }
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormLabel label="Invoice Date" required />
                <DatePicker
                  value={payload?.invoice_date}
                  onChange={date => handleChangePayload(date, "invoice_date")}
                  maxDate={moment(null)}
                />
              </Grid>
              {payload?.type !== "claim" && (
                <Grid item xs={12} md={6}>
                  <FormLabel label="Client Name" required />
                  <AutoCompleteWithSearch
                    placeholder="Client Name"
                    loading={loadingSearch}
                    options={optionClient}
                    optionLabel="name"
                    value={
                      optionClient.find(option => option.id === payloadDspId) ||
                      null
                    }
                    onChange={item => {
                      if (item) {
                        const getDsp = optionClient.find(
                          option => option.id === item?.master_client_id
                        );
                        const isRupiah = getDsp?.currency_symbol === "Rp";
                        handleChangePayload(
                          item?.master_client_id || "",
                          "dsp_id"
                        );
                        if (isRupiah) {
                          handleChangePayload(1, "exchange_rate");
                        }
                        isInitExchangeRate.current = false;
                      } else {
                        setPayload(currentState => ({
                          ...currentState,
                          dsp_id: 0,
                          exchange_rate: 0,
                        }));
                      }
                    }}
                    onInputChange={value => {
                      setSearchDsp(value);
                    }}
                    width="100%"
                  />
                </Grid>
              )}
              {!isEditing && isUsageInvoice && (
                <Grid item xs={12}>
                  <Grid container justifyContent="right">
                    <PrimaryButton
                      label="Add Client"
                      endIcon={<AddIcon />}
                      onClick={() =>
                        history.push("/admin/parameter/client/add", {
                          fromClaim: true,
                        })
                      }
                    />
                  </Grid>
                </Grid>
              )}
              {isUsageInvoice && (
                <Grid item xs={12} md={6}>
                  <FormLabel label="Usage Period" required />
                  <DateRangePicker
                    startDate={payload?.start_date}
                    endDate={payload?.end_date}
                    handleChangeStartDate={value =>
                      handleChangePayload(value, "start_date")
                    }
                    handleChangeEndDate={value =>
                      handleChangePayload(value, "end_date")
                    }
                    width="100%"
                    placeholder="Usage Period"
                    startMinDate={moment("2010-01", "YYYY-MM")}
                    endMaxDate={moment().add(10, "years")}
                  />
                </Grid>
              )}
              <Grid item xs={12} md={6}>
                {showExchangeRate && (
                  <Box>
                    <FormLabel
                      label="Exchange Rate"
                      required={isUsageInvoice}
                    />
                    <CurrencyNumberInput
                      placeholder="Exchange Rate"
                      value={payload?.exchange_rate}
                      startAdornment="Rp"
                      onChange={value =>
                        handleChangePayload(value, "exchange_rate")
                      }
                    />
                  </Box>
                )}
              </Grid>
              {isOverseas && (
                <Grid item xs={12} md={6}>
                  <FormLabel label="Job No" required />
                  <TextInput
                    placeholder="Job No"
                    value={payload?.job_number}
                    onChange={event =>
                      handleChangePayload(event?.target?.value, "job_number")
                    }
                  />
                </Grid>
              )}
              {isOverseas && (
                <Grid item xs={12} md={6}>
                  <FormLabel label="Account Number" required />
                  <SelectInput
                    options={optionBankAccount}
                    width="100%"
                    value={payload?.account_number || ""}
                    onChange={event =>
                      handleChangePayload(
                        event?.target?.value,
                        "account_number"
                      )
                    }
                    optionKey="account_number"
                    optionLabel="bank.name"
                    renderValue={id => {
                      let value = optionBankAccount?.find(
                        bank => bank?.account_number === id
                      );
                      return (
                        value && (
                          <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Grid item>
                              <Grid container columnSpacing={1}>
                                <Grid item>
                                  <img
                                    className={classes?.bankAccountImage}
                                    src={getNestedValue(
                                      value,
                                      "bank.profile_image"
                                    )}
                                    alt={"Bank"}
                                  />
                                </Grid>
                                <Grid item>
                                  {getNestedValue(value, "bank.name")}
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item>
                              {getNestedValue(value, "account_number")}
                            </Grid>
                          </Grid>
                        )
                      );
                    }}
                    placeholder="None"
                    label={payload?.account_number ? "" : "Account Number"}
                  />
                </Grid>
              )}
              {isUsageInvoice && (
                <Grid item xs={12}>
                  <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid item>
                      <SectionLabel title="Song Detail" />
                    </Grid>

                    <Grid item>
                      <Grid
                        container
                        justifyContent="flex-end"
                        columnSpacing={1}
                      >
                        {songDetailButtonAction?.map((item, index) => (
                          <Grid item key={index}>
                            <PrimaryButton
                              label={item?.label}
                              onClick={item?.onClick}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {!isUsageInvoice && (
                <Grid item xs={12} mt={2}>
                  <Grid container justifyContent="space-between">
                    <Grid item xs={6}>
                      <SearchTextInput
                        placeholder="Search"
                        value={tableParams?.search}
                        onChange={e =>
                          handleChangeTableParams(e?.target?.value, "search")
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Grid container justifyContent="flex-end">
                        <Grid item>
                          <MonthYearRangePicker
                            label="Period"
                            startMinDate={moment(2010, "YYYY")}
                            startDate={tableParams?.start_date}
                            handleChangeStartDate={handleChangeStartDate}
                            endDate={tableParams?.end_date}
                            handleChangeEndDate={handleChangeEndDate}
                            clear
                            width={300}
                          />
                        </Grid>
                        <Grid item ml={2}>
                          <AutoCompleteComponent
                            label="DSP"
                            width={200}
                            options={optionClient}
                            value={optionClient.find(
                              option => option.id === tableParams?.dsp_id
                            )}
                            onChange={value => {
                              const getDsp = optionClient.find(
                                option => option.id === value
                              );
                              const isRupiah =
                                getDsp?.dsp_currency?.currency_symbol_code ===
                                "Rp";
                              handleChangeTableParams(value, "dsp_id");
                              if (isRupiah) {
                                handleChangeTableParams(1, "exchange_rate");
                              }
                            }}
                            changeSearch={e => setSearchDsp(e?.target?.value)}
                            size="small"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12} my={1}>
                <CustomTable
                  isLoading={false}
                  data={isUsageInvoice ? payload?.songs : dataTable}
                  columnTable={columnTableSongDetail({
                    isUsageInvoice,
                    handleChangePayload,
                    payload,
                    selectedCurrencyCode,
                    optionListRightTypes,
                  })}
                  page={!isUsageInvoice && tableParams?.page}
                  pageSize={!isUsageInvoice && tableParams?.size}
                  pageCount={!isUsageInvoice && tableTotalPage}
                  handleChangePage={
                    isUsageInvoice
                      ? null
                      : (_, page) => handleChangeTableParams(page, "page")
                  }
                  handleChangePageSize={
                    isUsageInvoice
                      ? null
                      : e => handleChangeTableParams(e?.target?.value, "size")
                  }
                  rowClick={
                    isUsageInvoice
                      ? null
                      : item =>
                          disabledCheckbox(item)
                            ? null
                            : handleChangeCheckboxClaim(item)
                  }
                  isHaveAction={!isUsageInvoice}
                  renderAction={item => {
                    const isChecked = selectedClaims?.some(
                      claim =>
                        claim?.header_id === item?.header_id ||
                        claim === item?.header_id
                    );

                    const isDisabled = disabledCheckbox(item);

                    return (
                      <CheckboxInput
                        checked={isChecked}
                        onChange={() => handleChangeCheckboxClaim(item)}
                        disabled={isDisabled}
                        color={isDisabled && "grey"}
                      />
                    );
                  }}
                />
              </Grid>
              <Grid item xs={12} mb={1}>
                <SwitchInput
                  checked={showTaxes}
                  onChange={() => setShowTaxes(!showTaxes)}
                  label="Use taxes in this transaction"
                />
              </Grid>
              <Grid item xs={12} mb={1}>
                <SwitchInput
                  checked={isRounded}
                  onChange={() => handleChangePayload(!isRounded, "rounding")}
                  label="Use rounding amount in this transaction"
                />
              </Grid>
              <Grid item xs={12}>
                {showTaxes ? (
                  <Box>
                    <CustomTable
                      columnTable={columnTableTaxes}
                      data={dataTableTaxes}
                      rowClick={item => handleChangeCheckboxTaxes(null, item)}
                      isHaveAction
                      renderAction={item => {
                        const checked = selectedTaxes?.some(
                          selected => selected?.id === item?.id
                        );
                        return <CheckboxInput checked={checked} />;
                      }}
                    />
                    <Box
                      bgcolor="#fafafa"
                      borderRadius="6px"
                      p="14px"
                      mt="24px"
                    >
                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid item>Amount</Grid>
                        <Grid item>
                          <Typography fontSize={18}>
                            <CurrencyDisplay
                              value={totalFee}
                              prefix="Rp"
                              decimalScale={isRounded ? 0 : 2}
                              suffix=",-"
                            />
                          </Typography>
                        </Grid>
                      </Grid>
                      <Box mt="16px">
                        {checkSelectedTaxes &&
                          selectedTaxes?.map((item, index) => (
                            <Grid
                              container
                              key={index}
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Grid item>{item?.code}</Grid>
                              <Grid item>
                                <Typography fontSize={18}>
                                  <CurrencyDisplay
                                    value={calculateSingleTax(
                                      item,
                                      totalFee,
                                      isRounded
                                    )}
                                    prefix="Rp"
                                    decimalScale={isRounded ? 0 : 2}
                                    suffix=",-"
                                  />
                                </Typography>
                              </Grid>
                            </Grid>
                          ))}
                      </Box>
                      <Divider className={classes?.divider} />

                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="18px">
                            {`Total ${
                              payload?.type === "claim" ? "Fee" : "Amount"
                            }`}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="24px">
                            <CurrencyDisplay
                              value={
                                isRounded
                                  ? Math.round(totalRevenueAfterTax)
                                  : totalRevenueAfterTax
                              }
                              prefix="Rp"
                              decimalScale={isRounded ? 0 : 2}
                              suffix=",-"
                            />
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                ) : (
                  <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid item>
                      <Typography fontWeight="bold" fontSize="18px">
                        Total Amount :
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography fontWeight="bold" fontSize="24px">
                        <CurrencyDisplay
                          value={totalFee}
                          prefix="Rp"
                          decimalScale={isRounded ? 0 : 2}
                          suffix=",-"
                        />
                      </Typography>
                    </Grid>
                  </Grid>
                )}
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <Box justifyContent="flex-end" display="flex">
                  <Grid container justifyContent="flex-end" spacing={1}>
                    <Grid item>
                      <PrimaryButton
                        label="Save As Draft"
                        onClick={() => handleSubmitPayload(true)}
                        disabled={loadingPage || submiting}
                        loading={loadingPage || submiting}
                      />
                    </Grid>
                    <Grid item>
                      <PrimaryButton
                        label="Send To Approval"
                        onClick={() => handleSubmitPayload(false)}
                        disabled={loadingPage || submiting}
                        loading={loadingPage || submiting}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
          {showModalBulkAdd && (
            <ModalBulkAdd
              open={showModalBulkAdd}
              onClose={handleCloseModalBulkAdd}
              onSubmit={postUploadDocuments}
              loadingButton={loadingButton}
            />
          )}
          {showModalAddSong && (
            <ModalAddSong
              open={showModalAddSong}
              onClose={handleCloseModalAddSong}
              onSubmit={handleAddSong}
              preload={payload?.songs}
              optionListRightTypes={optionListRightTypes}
              selectedCurrencyCode={selectedCurrencyCode}
            />
          )}
          {showModalSongResults && (
            <ModalSongResults
              open={showModalSongResults}
              onClose={() => setShowModalSongResult(false)}
              preload={uploadedSong}
            />
          )}
          {showModalUploadResults && (
            <ModalUploadResults
              open={showModalUploadResults}
              onClose={() => setShowModalUploadResults(false)}
              preload={uploadedSong}
            />
          )}
        </Container>
      )}
    </Page>
  );
}

const isEmptyObject = obj => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};
const listInvoiceType = [
  { key: "claim", name: "Claim" },
  { key: "usage", name: "Usage" },
];
const breadcrumbData = pageTitle => [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Transaction",
    link: "/admin/sales-invoice",
  },
  {
    label: pageTitle,
    active: true,
  },
];
const columnTableTaxes = [
  {
    name: "code",
    title: "Code",
    renderText: item => item || "-",
  },
  {
    name: "description",
    title: "Description",
    renderText: item => item || "-",
  },
  {
    name: "rate",
    title: "Rate",
    renderText: item => `${item} %`,
  },
];

const buttonAddList = ({
  uploadedSong,
  setShowModalSongResult,
  showModalSongResults,
  setShowModalBulkAdd,
  showModalBulkAdd,
  setShowModalAddSong,
  showModalAddSong,
}) => [
  ...(isEmptyObject(uploadedSong)
    ? []
    : [
        {
          label: "Results",
          onClick: () => setShowModalSongResult(!showModalSongResults),
        },
      ]),
  {
    label: "Upload Song Detail",
    onClick: () => setShowModalBulkAdd(!showModalBulkAdd),
  },
  {
    label: "Add Song Detail",
    onClick: () => setShowModalAddSong(!showModalAddSong),
  },
];
const columnTableSongDetail = ({
  isUsageInvoice,
  handleChangePayload,
  payload,
  selectedCurrencyCode,
  optionListRightTypes,
}) => [
  ...(isUsageInvoice
    ? [
        {
          name: "song_title",
          title: "Song",
        },
        {
          name: "composers",
          title: "Composer/Author",
          renderText: composers => (
            <TableCellMultipleRow
              type="chip"
              list={composers}
              itemKey="sure_name"
            />
          ),
        },
        {
          name: "composers",
          title: "Ownership Percentage",
          renderText: item => (
            <TableCellMultipleRow
              type="chip"
              list={item}
              itemKey="ownership_percentage"
              suffix="%"
            />
          ),
        },
        {
          name: "right_type_id",
          title: "Type",
          renderText: right_type_id =>
            optionListRightTypes.find(({ id }) => id === right_type_id)
              ?.right_type_name || "-",
        },
        {
          name: "notes",
          title: "Notes",
        },
        {
          name: "all",
          title: "Amount",
          headerAlign: "right",
          renderText: item => (
            <CurrencyDisplay
              value={item?.revenue}
              decimalScale={2}
              suffix=",-"
              prefix={selectedCurrencyCode}
            />
          ),
        },
        {
          name: "all",
          title: "Action",
          renderText: item => (
            <TableAction
              handleDelete={() => {
                const modifiedTable = payload?.songs?.filter(
                  selected => selected.song_id !== item?.song_id
                );
                handleChangePayload(modifiedTable, "songs");
              }}
              width={30}
            />
          ),
        },
      ]
    : [
        {
          name: "dsp_name",
          title: "DSP",
        },
        {
          name: "period",
          title: "Reporting Period",
          renderText: date => formatPeriodMonthYearFromString(date),
        },
        {
          name: "file_name",
          title: "CCID/Source",
        },
        {
          name: "traffic",
          title: "Traffic",
          headerAlign: "right",
          renderText: item => <CurrencyDisplay value={item} />,
        },
        {
          name: "all",
          title: "Revenue",
          headerAlign: "right",
          renderText: item => (
            <CurrencyDisplay
              value={item?.original_currency_revenue}
              decimalScale={2}
              suffix=",-"
              prefix={`${item?.dsp_currency_symbol}`}
            />
          ),
        },
        {
          name: "all",
          title: "Exchange Rate",
          headerAlign: "right",
          renderText: item => (
            <CurrencyDisplay
              value={item?.exchange_rate}
              decimalScale={2}
              suffix=",-"
              prefix="Rp"
            />
          ),
        },
        {
          name: "all",
          title: "Base Revenue",
          headerAlign: "right",
          renderText: item => (
            <CurrencyDisplay
              value={item?.base_currency_revenue}
              decimalScale={2}
              suffix=",-"
              prefix="Rp"
            />
          ),
        },
        {
          name: "type",
          title: "Type",
          renderText: item =>
            item === "dsp"
              ? "DSP"
              : item === "non_dsp"
              ? "Non DSP"
              : textCapitalization(item),
        },
      ]),
];

export default FormInvoice;
